import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../../core/api';
import '../factors/Factors.css';
import './Staff.css';
import PermissionMatrix from './PermissionMatrix';
import StaffSkeleton from './StaffSkeleton';

const EMPTY = { fullName: '', phoneNumber: '', password: '', permissions: [] };

export default function Staff() {
  const [list, setList] = useState([]);
  const [groups, setGroups] = useState([]);
  const [form, setForm] = useState(EMPTY);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');
  const [type, setType] = useState('success');

  const show = (t, ty = 'success') => { setMessage(t); setType(ty); };

  const load = async () => {
    try {
      const [s, p] = await Promise.all([api.get('/staff'), api.get('/staff/permissions')]);
      setList(s.data.staff || []);
      setGroups(p.data.groups || []);
    } catch {
      show('خطا در دریافت اطلاعات پرسنل', 'danger');
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { load(); }, []);

  useEffect(() => {
    if (!message) return;
    const t = setTimeout(() => setMessage(''), 3000);
    return () => clearTimeout(t);
  }, [message]);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.post('/staff', form);
      setForm(EMPTY);
      show('پرسنل اضافه شد؛ در اولین ورود باید رمز جدید بسازد');
      load();
    } catch (err) {
      show(err.response?.data?.error || 'خطا در افزودن پرسنل', 'danger');
    } finally {
      setSaving(false);
    }
  };

  const remove = async (id) => {
    if (!window.confirm('این پرسنل حذف شود؟')) return;
    try {
      await api.post(`/staff/${id}/delete`);
      setList((p) => p.filter((s) => s.id !== id));
      show('پرسنل حذف شد');
    } catch (err) {
      show(err.response?.data?.error || 'خطا در حذف', 'danger');
    }
  };

if (loading) return <StaffSkeleton />;
  return (
    <>
      {message && <div className={type === 'danger' ? 'toast-danger' : 'toast-success'}>{message}</div>}

      <div className="card">
        <h2>افزودن پرسنل</h2>
        <form onSubmit={submit} autoComplete="off">
          <div className="grid">
            <div>
              <label>نام و نام خانوادگی</label>
              <input value={form.fullName} onChange={(e) => setForm({ ...form, fullName: e.target.value })} />
            </div>
            <div>
              <label>شماره موبایل *</label>
              <input required placeholder="09xxxxxxxxx" value={form.phoneNumber}
                onChange={(e) => setForm({ ...form, phoneNumber: e.target.value })} />
            </div>
            <div className="field-full">
              <label>رمز پیش‌فرض * (کاربر در اولین ورود باید آن را تغییر دهد)</label>
              <input required minLength={6} autoComplete="new-password" value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })} />
            </div>
          </div>

          <h2 style={{ marginTop: 22 }}>دسترسی‌ها</h2>
          <PermissionMatrix groups={groups} value={form.permissions}
            onChange={(permissions) => setForm({ ...form, permissions })} />

          <div className="flexend">
            <button className="btn" type="submit" disabled={saving}>
              {!saving && <i className="fa-solid fa-user-plus" />}
              {saving ? 'در حال افزودن...' : 'افزودن پرسنل'}
            </button>
          </div>
        </form>
      </div>

      <div className="card">
        <h2>لیست پرسنل</h2>
        {list.length === 0 ? (
          <div className="empty">هنوز پرسنلی ثبت نشده است.</div>
        ) : (
          list.map((s) => (
            <div className="list-item" key={s.id}>
              <div>
                <div>
                  <b>{s.fullName || s.phoneNumber}</b>{' '}
                  <span className="badge">{s.phoneNumber}</span>{' '}
                  {!s.isActive && <span className="badge" style={{ color: 'var(--danger)' }}>غیرفعال</span>}
                  {s.mustChangePassword && <span className="badge">رمز موقت</span>}
                </div>
                <div className="muted">{s.permissions.length.toLocaleString('fa-IR')} دسترسی</div>
              </div>
              <div className="row-actions">
                <Link className="btn secondary small" to={`/dashboard/staff/${s.id}/edit`}>
                  <i className="fa-solid fa-pen" /> ویرایش / دسترسی
                </Link>
                <button type="button" className="btn danger small" onClick={() => remove(s.id)}>
                  <i className="fa-solid fa-trash" /> حذف
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </>
  );
}